
import React, { useEffect, useState } from "react";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";
import { Link } from "react-router-dom";
import Select from "react-select";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

import * as api from "../constant/API";
import Utils from "../constant/Utils";
import Swal from "sweetalert2";

const Attendance = () => {

    const [isLoading, setIsLoading] = useState(false);
    const [showTable, setShowTable] = useState(false);
    const [mrkAtndcTable, setMrkAtndcTable] = useState(false);
    const [mrkAtndcStudList, setMrkAtndcStudList] = useState([]);
    const [gradeList, setGradeList] = useState([]);
    const [attendanceTypeList, setAttendanceTypeList] = useState([]);
    const [searchInput, setSearchInput] = useState('');
    const [institutionList, setInstitutionList] = useState([]);
    const [attendanceList, setAttendanceList] = useState([]);
    const [batchAttendanceList, setBatchAttendanceList] = useState([]);
    const [batchList, setBatchList] = useState([]);
    const [scheduleList, setScheduleList] = useState([]);
    const [instituteId, setInstituteId] = useState('');
    const [batchId, setBatchId] = useState('');
    const [scheduleId, setScheduleId] = useState('');
    const [scdlSkillName, setScdlSkillName] = useState('');
    const [scdlComment, setScdlComment] = useState('');
    const [scdlType, setScdlType] = useState('');
    const [atndcInstituteId, setAtndcInstituteId] = useState('');
    const [atndcBatchId, setAtndcBatchId] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [globalGrade, setGlobalGrade] = useState('');
    const [rowBatchDate, setRowBatchDate] = useState('');
    const [grade, setGrade] = useState([]);
    const [mrkAtnd, setMrkAtnd] = useState({});
    const [comment, setComment] = useState({});
    const [bchPlaceHolder, setBchPlaceHolder] = useState('Please Wait...');
    const [scdlPlaceHolder, setScdlPlaceHolder] = useState('Please Wait...');

    const roleId = localStorage.getItem('RoleId');

    useEffect(() => {
        getGradeList();
        getAttendanceTypeList();
        getInstitutionList();
    }, [])

    function getGradeList() {
        const gradeList = api.GradeList;
        fetch(gradeList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((grdResponse) => grdResponse.json())
            .then((grdResult) => {
                if (grdResult.error == false) {
                    setGradeList(grdResult.data);
                }
                else {
                    Swal.fire(grdResult.message);
                    if (grdResult.code == 401) {
                        Utils.logoutUser();
                    }
                }
            })
            .catch((error) => {
                console.log("Failed to fetch Grade List", error);
            })
    }

    function getAttendanceTypeList() {
        const attendanceList = api.AttendanceTypeList;
        fetch(attendanceList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((atndResponse) => atndResponse.json())
            .then((atndResult) => {
                if (atndResult.error == true) {
                    if (atndResult.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire(atndResult.message)
                }
                else {
                    setAttendanceTypeList(atndResult.data)
                    if (mrkAtnd.length === 0) {
                        const defaultAttendance = mrkAtndcStudList.map(() => "1");
                        setMrkAtnd(defaultAttendance);
                    }
                }
            })
            .catch((error) => {
                console.log("Failed to fetch Attendance Type List", error);
            })
    }

    function getInstitutionList() {
        const instList = api.InstDd + '/' + roleId; //'/?userId=' + userId + '&roleId=' + roleId;
        fetch(instList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((insResponse) => insResponse.json())
            .then((insResult) => {
                if (insResult.error == false) {
                    setInstitutionList(insResult.data)
                }
                else {
                    Swal.fire(insResult.message)
                    if (insResult.code == 401) {
                        Utils.logoutUser();
                    }
                }
            })
            .catch((error) => {
                console.log("Failed to fetch the Institution List", error);
            })
    }

    function initialValues() {
        setAtndcInstituteId("")
        setAtndcBatchId("")
        setScheduleId("")
        setMrkAtndcStudList([])
        setMrkAtndcTable(false)
    }

    function listBatch(insId) {
        const instId = insId;
        const fetchBatches = api.BatchByInstitution + '/' + instId; // "/?userId=" + userId + "&roleId=" + roleId + "&insId=" + instId;
        fetch(fetchBatches, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((bchResponse) => bchResponse.json())
            .then((bchResult) => {
                if (bchResult.error == false) {
                    setBatchList(bchResult.data);
                    setBchPlaceHolder("Select a Batch");
                }
                else {
                    Swal.fire(bchResult.message)
                    if (bchResult.code == 401) {
                        Utils.logoutUser();
                    }
                }
            })
            .catch((error) => {
                console.log("Error fetching Batch List", error);
            })
    }

    function getAttendanceList() {
        const atndc = api.AttendanceList + '/' + batchId + '/' + fromDate + '/' + toDate + '/' + instituteId;
        //"?insId=" + instituteId + "&batchId=" + batchId + "&dateFrom=" + fromDate + "&dateTo=" + toDate;
        fetch(atndc, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((atndcResponse) => atndcResponse.json())
            .then((atndcResult) => {
                if (atndcResult.error == false) {
                    setAttendanceList(atndcResult.data);
                    setShowTable(true)
                }
                else {
                    Swal.fire(atndcResult.message)
                    if (atndcResult.code == 401) {
                        Utils.logoutUser();
                    }
                }
            })
            .catch((error) => {
                console.log("Failed to fetch the Attendance List", error);
            })
    }

    function viewDetails(selectedBatch) {
        const scheduleId = selectedBatch.scheduleId;
        setRowBatchDate(formatDate(selectedBatch.scheduleDate))
        const atndcList = api.BatchAttendanceList + '/' + batchId + '/' + scheduleId + '/' + instituteId;
        // "?id=" + batchId + "&sid=" + scheduleId + "&insId=" + instituteId;
        fetch(atndcList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((atndcResponse) => atndcResponse.json())
            .then((atndcResult) => {
                if (atndcResult.error == false) {
                    setBatchAttendanceList(atndcResult.data);
                }
                else {
                    setBatchAttendanceList([]);
                    Swal.fire(atndcResult.message)
                    if (atndcResult.code == 401) {
                        Utils.logoutUser();
                    }
                }
            })
            .catch((atndcError) => {
                console.log("Failed to fetch Attendance list", atndcError);
            })
    }

    function listSchedules(selectedBatch) {
        const scdlList = api.ScheduleByInstitution + '/' + selectedBatch + '/' + atndcInstituteId;//"?insId=" + atndcInstituteId + "&batchId=" + selectedBatch;
        fetch(scdlList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((scdlResponse) => scdlResponse.json())
            .then((scdlResult) => {
                if (Array.isArray(scdlResult.data)) {
                    console.log("data:", scdlResult.data)
                    setScheduleList(scdlResult.data);
                    setScdlPlaceHolder("Select a Schedule");
                }
                else {
                    Swal.fire(scdlResult.message)
                    setScheduleList([]);
                    if (scdlResult.code == 401) {
                        Utils.logoutUser();
                    }
                }
            })
            .catch((scdlError) => {
                console.log("Failed to fetch list of schedule", scdlError);
            })
    }

    function mrkAtndcStudentList(selectedSchedule) {
        setMrkAtndcTable(true);
        const studList = api.AttendanceStudentList + '/' + atndcBatchId + '/' + selectedSchedule + '/' + atndcInstituteId;
        // "?insId=" + atndcInstituteId + "&batchId=" + atndcBatchId + "&scheduleId=" + selectedSchedule;
        fetch(studList, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((lstResponse) => lstResponse.json())
            .then((lstResult) => {
                if (lstResult.error == true) {
                    Swal.fire(lstResult.message)
                    if (lstResult.code == 401) {
                        Utils.logoutUser();
                    }
                }
                else {
                    setMrkAtndcStudList(lstResult.data);
                    const defaultAttendance = lstResult.data.map(() => "1");
                    setMrkAtnd(defaultAttendance);
                    setScdlSkillName(lstResult.data[0]?.skillName?.trim() || "");
                    setScdlType(lstResult.data[0]?.schedulesName?.trim() || "");
                    setScdlComment(lstResult.data[0]?.scheduleComments?.trim() || "");
                }
            })
            .catch((lstError) => {
                console.log("Failed to fetch Student list", lstError);
            })
    }

    const filteredData = attendanceList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const formatDate = (date) => {
        const dateObj = new Date(date);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const detailsRender = (rowData) => {
        return (
            <Link to="#" data-bs-toggle="modal" data-bs-target="#attendance-list" onClick={() => viewDetails(rowData)}>
                <i className="feather feather-eye"></i>View Details
            </Link>
        );
    };

    function saveAttendance() {

        const attendanceDataArray: { attendanceUserId: any; attendanceGrade: string; attendanceComments: string; attendanceInstitution: string; attendanceBatch: string; attendanceSchedule: string; attendanceSkill: any; attendanceMark: string; }[] = [];

        setIsLoading(true)
        setTimeout(() => {
            // Populate the array with data
            mrkAtndcStudList.forEach((stud, index) => {
                const effectiveGrade = grade[index] || globalGrade;

                attendanceDataArray.push({
                    attendanceUserId: stud.coreUserId,
                    // attendanceGrade: grade[index],
                    attendanceGrade: effectiveGrade,
                    attendanceComments: comment[index] ?? "",
                    attendanceInstitution: atndcInstituteId,
                    attendanceBatch: atndcBatchId,
                    attendanceSchedule: scheduleId,
                    attendanceSkill: stud.skillName,
                    attendanceMark: mrkAtnd[index]
                });
            });

            // attendanceDataArray.forEach((data) => {
            //     console.log(data);
            // });


            // attendanceDataArray.forEach(data => {
            //     const formData = new FormData();
            //     formData.append('attendanceUserId', data.attendanceUserId);
            //     formData.append('attendanceGrade', data.attendanceGrade);
            //     formData.append('attendanceComments', data.attendanceComments);
            //     formData.append('attendanceInstitution', data.attendanceInstitution);
            //     formData.append('attendanceBatch', data.attendanceBatch);
            //     formData.append('attendanceSchedule', data.attendanceSchedule);
            //     formData.append('attendanceSkill', data.attendanceSkill);
            //     formData.append('attendanceMark', data.attendanceMark);

            const saveAtndc = api.CreateNewAttendanceList;
            fetch(saveAtndc, {
                method: "POST",
                headers: {
                    "Authorization": 'Bearer ' + Utils.getAccessToken(),
                    "Content-Type": "application/json" // Sending JSON
                },
                // body: formData,
                body: JSON.stringify(attendanceDataArray)
            })
                .then((svdAtndcResponse) => svdAtndcResponse.json())
                .then((svdAtndcResult) => {
                    if (svdAtndcResult.error == false) {
                        setIsLoading(false);
                        Swal.fire(svdAtndcResult.message)
                    }
                    else {
                        setIsLoading(false);
                        Swal.fire(svdAtndcResult.message)
                        if (svdAtndcResult.code == 401) {
                            Utils.logoutUser();
                        }
                    }
                })
                .catch((error) => {
                    console.log('Failed to save the attendance', error)
                })

            // });

            attendanceDataArray.length = 0;


            // formData.forEach((value, key) => {
            //     console.log(`${key}: ${value}`);
            // });
        }, 1000)

    }
    const markAtt = (e, indx) => {
        const updatedAttendance = { ...mrkAtnd, [indx]: e.target.value };
        console.log(updatedAttendance)

        // If attendance type 2 is selected, set grade to 6
        const updatedGrade = [...grade]; // Make a copy of the current grade state
        if (e.target.value === "2") {
            updatedGrade[indx] = "6"; // Set grade to 6 for the specific student (row)
        }

        setMrkAtnd(updatedAttendance)
        setGrade(updatedGrade)
    }

    // Global handler
    const handleGlobalGradeChange = (e) => {
        const newGrade = e.target.value;
        setGlobalGrade(newGrade);
    };

    const handleGradeChange = (e, indx) => {
        // const updatedGrades = { ...grade, [indx]: e.target.value };
        const updatedGrades = [...grade]; // Make a copy of the grade array
        updatedGrades[indx] = e.target.value; // Update the specific grade at indx
        setGrade(updatedGrades);
    };

    const handleCommentChange = (e, indx) => {
        const updatedComment = { ...comment, [indx]: e.target.value };
        // console.log(updatedComment)
        setComment(updatedComment);
    };

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const batchRender = (rowData, column) => {
        return <span>{rowData.batchName}</span>;
    };

    const dateRender = (rowData) => {
        return <span>{formatDate(rowData.scheduleDate)}</span>;
    };

    return (
        <>
            {isLoading && (
                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container">
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row d-flex align-items-center">
                                <h4 className="text-center mb-40">Attendance</h4>
                            </div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="court-tab-content">
                                        <div className="card card-tableset">
                                            <div className="card-body">
                                                <div className="coache-head-blk">
                                                    <div className="row align-items-center">
                                                        <div className="row col-md-12">
                                                            <div className="row col-md-12">
                                                                {(roleId == '1' || roleId == '6') && (
                                                                    <>
                                                                        <div className="col-md-4">
                                                                            <Link
                                                                                to="#"
                                                                                className="btn btn-secondary"
                                                                                onClick={initialValues}
                                                                                data-bs-toggle="modal"
                                                                                data-bs-target="#add-attendance">
                                                                                <i className="feather-plus" />&nbsp;
                                                                                Add Attendance
                                                                            </Link>
                                                                        </div>
                                                                    </>
                                                                )}
                                                            </div>
                                                            <div className="col-md-12"></div>
                                                            <div className="col-md-12 border-bottom" style={{ marginTop: "1rem", marginBottom: "1rem" }} />
                                                            <div className="row col-md-12 court-sortby sortbyset">
                                                                <div className="col-lg-4 mb-10">
                                                                    <label className="sortbytitle"><h6>Institute</h6></label>
                                                                    <Select
                                                                        value={institutionList.find(ins => ins.institutionId === instituteId) ? {
                                                                            value: instituteId,
                                                                            label: institutionList.find(ins => ins.institutionId === instituteId).institutionName
                                                                        } : null}
                                                                        onChange={(e) => {
                                                                            setInstituteId(e.value);
                                                                            listBatch(e.value)
                                                                        }}
                                                                        options={institutionList.map(ins => ({
                                                                            value: ins.institutionId,
                                                                            label: ins.institutionName
                                                                        }))}>
                                                                    </Select>
                                                                </div>
                                                                <div className="col-lg-4 mb-10">
                                                                    <label className="sortbytitle"><h6>Batch</h6></label>
                                                                    <Select value={batchList.find(bch => bch.batchId === batchId) ? {
                                                                        value: batchId,
                                                                        label: batchList.find(bch => bch.batchId === batchId).batchName +
                                                                            '( ' + batchList.find(bch => bch.batchId === batchId).ProgramName + ' )'
                                                                    } : null}
                                                                        onChange={(e) => { setBatchId(e.value) }}
                                                                        options={batchList.map(bch => ({
                                                                            value: bch.batchId,
                                                                            label: bch.batchName + '( ' + bch.ProgramName + ' )'
                                                                        }))}
                                                                        placeholder={bchPlaceHolder}
                                                                    />
                                                                </div>
                                                                <div className="col-md-2">
                                                                    <div className="mb-10">
                                                                        <label className="sortbytitle"><h6>From Date</h6></label>
                                                                        <input type="date" style={{ border: "1px solid hsl(0, 0%, 80%)", borderRadius: "4px", minHeight: "38px" }} value={fromDate} onChange={(e) => setFromDate(e.target.value)}></input>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-2">
                                                                    <div className="mb-10">
                                                                        <label className="sortbytitle"><h6>To Date</h6></label>
                                                                        <input type="date" style={{ border: "1px solid hsl(0, 0%, 80%)", borderRadius: "4px", minHeight: "38px" }} value={toDate} onChange={(e) => setToDate(e.target.value)}></input>
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-2">
                                                                    <div className="table-accept-btn" style={{ marginTop: "1.8rem" }}>
                                                                        <Link to="#" className="btn btn-primary close" style={{ padding: "7px 60px" }} onClick={getAttendanceList}>
                                                                            <i className="feather-eye"></i>Show
                                                                        </Link>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {
                                                            showTable && (
                                                                <>
                                                                    <div className="col-md-12">
                                                                    </div>
                                                                    <div className="col-md-12">
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                    </div>
                                                                    <div className="col-md-6">
                                                                        <div className="dataTables_filter">
                                                                            <label>
                                                                                <input
                                                                                    type="text"
                                                                                    value={searchInput}
                                                                                    onChange={(e) => setSearchInput(e.target.value)}
                                                                                    placeholder="Search"
                                                                                    className="form-control"
                                                                                />
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )
                                                        }
                                                    </div>
                                                </div>
                                                {showTable && (
                                                    <div className="tab-content">
                                                        <div
                                                            className="tab-pane fade show active"
                                                            id="nav-Recent"
                                                            role="tabpanel"
                                                            aria-labelledby="nav-Recent-tab"
                                                            tabIndex={0}
                                                        >
                                                            <div className="table-responsive table-datatble">
                                                                <DataTable
                                                                    className="table datatable"
                                                                    value={filteredData}
                                                                    paginator
                                                                    rows={10}
                                                                    rowsPerPageOptions={[10, 25, 50, 100]}
                                                                    // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                                                    pageLinkSize={3}
                                                                >
                                                                    <Column
                                                                        sortable
                                                                        headerClassName="text-uppercase"
                                                                        field="slNo"
                                                                        body={slNoRender}
                                                                        header="Sl No"
                                                                    ></Column>
                                                                    <Column
                                                                        sortable
                                                                        headerClassName="text-uppercase"
                                                                        field="batchName"
                                                                        body={batchRender}
                                                                        className="table-inset-btn"
                                                                        header="Batch"
                                                                    ></Column>
                                                                    <Column
                                                                        sortable
                                                                        headerClassName="text-uppercase"
                                                                        field="scheduleDate"
                                                                        body={dateRender}
                                                                        className="table-inset-btn"
                                                                        header="Schedule Date"
                                                                    ></Column>
                                                                    <Column
                                                                        className="text-link view-detail-pink"
                                                                        style={{ color: "#0F2A4E" }}
                                                                        body={detailsRender}
                                                                    ></Column>
                                                                </DataTable>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Batch Attendance List */}

            <div
                className="modal custom-modal fade request-modal"
                id="attendance-list"
                role="dialog"
            >
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="form-header modal-header-title">
                                <h4 className="mb-0">
                                    Student Attendance {rowBatchDate}
                                </h4>
                            </div>
                            <Link
                                to="#"
                                className="close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            >
                                <span className="align-center" aria-hidden="true">
                                    <i className="feather-x" />
                                </span>
                            </Link>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="table-responsive table-datatble">
                                    <table className="table datatable">
                                        <thead className="thead-light">
                                            <tr>
                                                <th className="text-uppercase">Student ID</th>
                                                <th className="text-uppercase">Student Name</th>
                                                <th className="text-uppercase">Attendance</th>
                                                <th className="text-uppercase">Grade</th>
                                                <th className="text-uppercase">Comments</th>
                                            </tr>
                                            {Array.isArray(batchAttendanceList) && batchAttendanceList.map((atndc, index) => (
                                                <tr key={index}>
                                                    <td>{atndc.StudentId}</td>
                                                    <td>{atndc.StudentName}</td>
                                                    <td>{atndc.attendanceTypeName}</td>
                                                    <td>{atndc.gradeType}</td>
                                                    <td>{(atndc.attendanceComments == 'undefined' ? '' : atndc.attendanceComments)}</td>
                                                </tr>
                                            ))}
                                        </thead>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Batch Attendance List */}

            {/* Add Attendance */}
            <div
                className="modal custom-modal fade request-modal"
                id="add-attendance"
                role="dialog"
            >
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="form-header modal-header-title">
                                <h4 className="mb-0">
                                    Mark Attendance
                                </h4>
                            </div>
                            <Link
                                to="#"
                                className="close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            >
                                <span className="align-center" aria-hidden="true">
                                    <i className="feather-x" />
                                </span>
                            </Link>
                        </div>
                        <div className="modal-body">
                            <div className="row">

                                <div className="col-md-12"></div>
                                <div className="row col-md-12 court-sortby sortbyset">
                                    <div className="col-md-3">
                                        <div className="mb-10">
                                            <label className="sortbytitle"><h6>Institute</h6></label>
                                            <Select
                                                value={institutionList.find(ins => ins.institutionId === atndcInstituteId) ? {
                                                    value: instituteId,
                                                    label: institutionList.find(ins => ins.institutionId === atndcInstituteId).institutionName
                                                } : null}
                                                onChange={(e) => {
                                                    setAtndcInstituteId(e.value);
                                                    setMrkAtndcStudList([])
                                                    setAtndcBatchId('')
                                                    setScheduleId('')
                                                    listBatch(e.value)
                                                }}
                                                options={institutionList.map(ins => ({
                                                    value: ins.institutionId,
                                                    label: ins.institutionName
                                                }))}>
                                            </Select>
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="mb-10">
                                            <label className="sortbytitle"><h6>Batch</h6></label>
                                            <Select value={batchList.find(bch => bch.batchId === atndcBatchId) ? {
                                                value: batchId,
                                                label: batchList.find(bch => bch.batchId === atndcBatchId).batchName
                                            } : null}
                                                onChange={(e) => {
                                                    setAtndcBatchId(e.value);
                                                    setScheduleId('')
                                                    setMrkAtndcStudList([])
                                                    listSchedules(e.value);
                                                }}
                                                options={batchList.map(bch => ({
                                                    value: bch.batchId,
                                                    label: bch.batchName
                                                }))}
                                                placeholder={bchPlaceHolder}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-md-3">
                                        <div className="mb-10">
                                            <label className="sortbytitle"><h6>Schedule</h6></label>
                                            <Select value={scheduleList.find(scdl => scdl.scheduleId === scheduleId) ? {
                                                value: scheduleId,
                                                label: formatDate(scheduleList.find(scdl => scdl.scheduleId === scheduleId)?.scheduleDate)
                                            } : null}
                                                onChange={(e) => {
                                                    setScheduleId(e.value)
                                                    mrkAtndcStudentList(e.value);
                                                }}
                                                options={scheduleList.map(scdl => ({
                                                    value: scdl.scheduleId,
                                                    label: formatDate(scdl.scheduleDate)
                                                }))}
                                                placeholder={scdlPlaceHolder}
                                            />
                                        </div>
                                    </div>
                                </div>

                                {mrkAtndcTable && (
                                    <>
                                        <div className="row col-md-12 ">
                                            <p className="mb-1"><b>Skill Taught - </b>{scdlSkillName} <b>Schedule Comment - </b>{scdlComment}<b>Schedule Type - </b>{scdlType}</p>
                                        </div>
                                        <div className="row">
                                            <div className="table-responsive table-datatble">
                                                <table className="table datatble">
                                                    <thead className="thead-light">
                                                        <tr>
                                                            <th className="text-upper">Name</th>
                                                            <th className="text-upper">Attendance</th>
                                                            <th className="text-upper">Grade
                                                                <select value={globalGrade} onChange={handleGlobalGradeChange}>
                                                                    <option value="" disabled>Select Grade</option>
                                                                    {gradeList.map((grd) => (
                                                                        <option key={grd.gradeTypeId} value={grd.gradeTypeId}>
                                                                            {grd.gradeType}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </th>
                                                            <th className="text-upper">Comment</th>
                                                        </tr>
                                                        {Array.isArray(mrkAtndcStudList) && mrkAtndcStudList.map((stud, index) => (
                                                            <tr key={index}>
                                                                <td>{stud.StudentName}</td>
                                                                <td style={{ paddingRight: '4rem' }}>
                                                                    {Array.isArray(attendanceTypeList) && attendanceTypeList.map((atndc) => (
                                                                        <div key={atndc.attendanceTypeId} className="form-check form-check-inline">
                                                                            <input
                                                                                type="radio"
                                                                                id={`attendance_${index}_${atndc.attendanceTypeId}`}
                                                                                value={atndc.attendanceTypeId}
                                                                                checked={mrkAtnd[index] === String(atndc.attendanceTypeId)}
                                                                                onChange={(e) => markAtt(e, index)}
                                                                                className="form-check-input default-check me-2"
                                                                            />
                                                                            <label>{atndc.attendanceTypeName}</label>
                                                                        </div>
                                                                    ))}
                                                                </td>
                                                                <td>
                                                                    {/* <select value={grade[index]} onChange={(e) => handleGradeChange(e, index)}>
                                                                        <option value="" selected disabled>Select grade</option>
                                                                        {Array.isArray(gradeList) && gradeList.map((grd) => (
                                                                            <option key={grd.gradeTypeId} value={grd.gradeTypeId}>{grd.gradeType}</option>
                                                                        ))}
                                                                    </select> */}
                                                                    <select
                                                                        value={grade[index] !== undefined && grade[index] !== '' ? grade[index] : globalGrade}
                                                                        onChange={(e) => handleGradeChange(e, index)}
                                                                    >
                                                                        <option value="">Select Grade</option>
                                                                        {gradeList.map((grd) => (
                                                                            <option key={grd.gradeTypeId} value={grd.gradeTypeId}>
                                                                                {grd.gradeType}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </td>
                                                                <td>
                                                                    <input type="text" value={comment[index]} onChange={(e) => handleCommentChange(e, index)} />
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </thead>
                                                </table>
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="table-accept-btn">
                                <Link to="#" className="btn btn-primary close" onClick={saveAttendance} data-bs-dismiss="modal" aria-label="Close">
                                    Save
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Add Attendance */}
        </>
    )

}

export default Attendance;